import { createFeatureSelector } from '@ngrx/store';
import { UserPreferenceState } from './user-preference.reducer';

export const getUserPreferences =
  createFeatureSelector<UserPreferenceState>('userPreferences');
